import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import ArrayUtil from '../../../utils/ArrayUtil';

export const RESPONDENT_QUERY = gql`
  query getRespondent($accountId: ID!, $respondentId: ID!) {
    account(id: $accountId) {
      id
      respondent(id: $respondentId) {
        id
        email
        phoneNumber
        firstName
        lastName
        gender
        createdOn
        updatedOn
        lastInvitedOn
        lastAssessedOn
        locale
        type
        notes
        anonymizedOn
        scheduledForAnonymizationOn
        createdBy {
          id
          firstName
          lastName
        }
        globalAriFields {
          id
          question
          mandatory
          answer
          inputType
          dropdownAnswers
        }
        localAriFields {
          id
          question
          mandatory
          answer
          inputType
          dropdownAnswers
        }
        targetJob {
          id
          name
          assessmentTemplate {
            id
            title
          }
        }
        wasAddedViaSuperMatch
      }
    }
  }
`;

const getRespondentDetail = graphql(RESPONDENT_QUERY, {
  name: 'getRespondentDetail',
  options: ({ match }) => {
    const { respondentId, aid } = match.params;
    return {
      variables: {
        accountId: aid,
        respondentId,
      },
      fetchPolicy: 'network-only',
    };
  },
});

export const RESPONDENT_ASMT_QUERY = gql`
  query($accountId: ID!, $respondentId: ID!) {
    account(id: $accountId) {
      id
      respondent(id: $respondentId) {
        id
        timeline {
          edges {
            node {
              __typename
              ... on Assessment {
                id
                status
                template {
                  id
                  title
                }
                previewInviteUrl
                previewReminderUrl
                startUrl
                createdOn
                updatedOn
                submittedOn
                startedOn
                invitedOn
                expiredOn
                declinedOn
              }
              ... on SurveyRespondent {
                id
                status
                template {
                  id
                  title
                }
                previewInviteUrl
                previewReminderUrl
                startUrl
                createdOn
                updatedOn
                submittedOn
                startedOn
                invitedOn
                expiredOn
                declinedOn
                survey {
                  id
                  self {
                    respondent {
                      firstName
                      lastName
                    }
                  }
                }
              }
              ... on JobProfileSurvey {
                id
                status
                jobProfile {
                  id
                  assessmentTemplate {
                    id
                    title
                  }
                }
                previewInviteUrl
                previewReminderUrl
                startUrl
                createdOn
                updatedOn
                submittedOn
                startedOn
                invitedOn
                declinedOn
                expiredOn
              }
            }
          }
        }
      }
    }
  }
`;
const getRespondentAsmt = graphql(RESPONDENT_ASMT_QUERY, {
  name: 'respondentAsmt',
  options: ({ match }) => {
    const { respondentId, aid } = match.params;
    return {
      variables: {
        respondentId,
        accountId: aid,
        first: 200,
      },
      fetchPolicy: 'no-cache',
    };
  },
  props: ({ respondentAsmt }) => {
    const { account } = respondentAsmt;
    const { respondent } = account || {};
    const { timeline } = respondent || { timeline: {} };
    const timelineArr = ArrayUtil.isNotEmpty(timeline.edges) ? timeline.edges.map(item => item.node) : [];
    return {
      respondentAsmt: {
        ...respondentAsmt,
        account: {
          ...account,
          respondent: {
            ...respondent,
            timeline: timelineArr,
            timelineArr,
          },
        },
      },
    };
  },
});

export default compose(
  getRespondentDetail,
  getRespondentAsmt,
);
